<script>
  import { INCLUDE_SECTORS } from "./stores";
  import { Router, Route } from "svelte-routing";
  import Reports from "./pages/Reports.svelte";
  import Sectors from "./pages/Sectors.svelte";
  import Search from "./pages/Search.svelte";
  import Sector from "./pages/Sector.svelte";
  import Summary from "./pages/Summary.svelte";
  import SubscribeFooter from "./components/Reports/SubscribeFooter.svelte";
</script>

<Router basepath="/reports">
  <!-- routes -->
  <Route path="/" component={Reports} />
  <Route path="/search" component={Search} />

  <Route path="summaries/:slug" let:params>
    <Summary slug={params.slug} />
  </Route>

  {#if INCLUDE_SECTORS}
    <Route path="sectors" component={Sectors} />
    <Route path="sectors/:slug" let:params>
      <Sector slug={params.slug} />
    </Route>
  {/if}

  <SubscribeFooter />
</Router>
